import { Box, Button, Rating, TextField } from "@mui/material";
import { useEffect, useState } from "react";

import UgskLogo from "shared/assets/UgskLogo";
import healthAIBanner from "shared/assets/images/HealthBanner.png";

import styles from "./FeedbackMaxBot.module.css";
import { useLocation } from "react-router-dom";
import { getRequestProductSales } from "shared/utils/fetch-api";
import Loader from "shared/loader/Loader";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
const FeedbackMaxBot: React.FC = () => {
  const [value, setValue] = useState<number | null>(null);
  const [comment, setComment] = useState("");
  const location = useLocation();

  const [errorLink, setErrorLink] = useState<boolean>(false);
  const [succeses, setSucceses] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const searchParams = new URLSearchParams(location.search);

  const policyIdfromProduct = location.state?.policyId;
  const masterSystemfromProduct = location.state?.masterSystem;

  const policyId = searchParams.get("PolicyId") || policyIdfromProduct || "";
  const masterSystem = searchParams.get("MasterSystem") || masterSystemfromProduct || "";
  useEffect(() => {
    if (!policyId || !masterSystem) {
      setErrorLink(true);
      return;
    }
    setErrorLink(false);
  }, [policyId]);

  const handleSubmit = async () => {
    if (!value) {
      return;
    }
    if (masterSystem === "0") {
      setIsLoading(true);
      try {
        const response = await getRequestProductSales(
          { PolicyId: policyId, Rating: value, Review: comment },
          "product-sales",
          "sendReview",
          "POST"
        );
        const result = await response.json();
        if (result.Result) {
          setSucceses(true);
        }
      } catch (error) {
        console.error("Ошибка при отправки отзыва");
      } finally {
        setIsLoading(false);
      }
    } else {
      console.log("Другая система");
    }
  };

  if (succeses) {
    return (
      <Box className={styles.mainBox}>
        <UgskLogo />

        <Box className={styles.successMessage}>
          <span>
            <CheckCircleOutlineIcon />
          </span>
          <p>Спасибо за ваш отзыв!</p>
        </Box>
      </Box>
    );
  }
  if (isLoading) {
    return <Loader title="Отправляем отзыв..." />;
  }
  if (errorLink) {
    return (
      <Box className={styles.mainBox}>
        <UgskLogo />

        <Box className={styles.errorBox}>
          <p>Некорректная ссылка</p>
        </Box>
      </Box>
    );
  }
  return (
    <Box className={styles.mainBox}>
      <UgskLogo />

      <Box className={styles.container}>
        <Box className={styles.title}>
          <h4>Оцените удобство оформления и покупки</h4>
        </Box>

        <Box className={styles.boxImg}>
          <img src={healthAIBanner} alt="banner" />
        </Box>

        <Box className={styles.feedbackBox}>
          <Box className={styles.ratingBlock}>
            <Rating
              name="feedback-rating"
              value={value}
              max={5}
              size="large"
              onChange={(_, newValue) => {
                setValue(newValue);
              }}
              className={styles.rating}
              aria-label="Оценка удобства"
            />

            <Box className={styles.ratingLabels}>
              <span>Совсем не удобно</span>
              <span>Все отлично</span>
            </Box>
          </Box>

          <TextField
            className={styles.commentField}
            value={comment}
            onChange={(event) => setComment(event.target.value)}
            placeholder="Расскажите, что можно улучшить"
            multiline
            minRows={4}
            maxRows={7}
            fullWidth
          />

          <Box className={styles.btnBox}>
            <Button
              className={styles.gradientButton}
              variant="contained"
              disabled={!value}
              onClick={handleSubmit}
            >
              Оставить отзыв
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FeedbackMaxBot;
